module.exports = __webpack_public_path__ + "static/media/bitcoin-png-image-68816.74d7bf95.png";